import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './app/App'
import { VersionGate } from './version/VersionGate'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <VersionGate>
      <App />
    </VersionGate>
  </StrictMode>,
)
